import type from '@/helpers/rave/constants/types'

export default {
  [type.GENERATOR]: 'To Respond',
  [type.MAN_GENERATOR]: 'To Respond',
  [type.MANIFESTOR]: 'To Inform',
  [type.PROJECTOR]: 'Wait for the Invitation',
  [type.REFLECTOR]: 'Wait a Lunar Cycle'
}
